import { render } from "./DialogErro.vue?vue&type=template&id=1cc87150"
import script from "./DialogErro.vue?vue&type=script&lang=js"
export * from "./DialogErro.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__